export const ALL_CITIES_OPTION_ID = '__all_cities_of_country__';

export const ALL_CITIES_OPTION = {
  _id: ALL_CITIES_OPTION_ID,
  name: 'Все города',
  is_in_all_cities_of_country: true,
};

export function buildAllCitiesSelection(country) {
  if (!country?._id) return null;
  return {
    name: 'Все города',
    country_id: country._id,
    country: {
      _id: country._id,
      name: country.name,
    },
    is_in_all_cities_of_country: true,
  };
}

export function isAllCitiesSelection(city) {
  return Boolean(city?.is_in_all_cities_of_country);
}
